import { Component } from '@angular/core';

import { MenuDisplayMode } from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';

import { LoginItemBase } from '../../../login-item-base';

@Component({
    imports: [MenuItemComponent],
    selector: 'vn-l-icon',
    templateUrl: 'icon.html',
})
export class IconComponent extends LoginItemBase {
    constructor() {
        super();
    }

    protected readonly MenuDisplayMode = MenuDisplayMode;
}
